import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
/**
 * @description 角色同步组件，通过cookie进行角色传递，主要功能
 * 1. 将角色信息转为字符串，然后存储在cookie，然后对应的key
 * 2. 从url中获取角色在cookie中的key值，然后从cookie中获取角色信息，将其转化为结构体
 * 3. (待办)获取角色数据之后，删除对应的cookie值
 */
import { getParameterByName } from "../method/query";

/**
 * @description url中默认键值key
 */
export var DEFAULT_COOKIE_KEY_OF_ROLE = 'upRoleKey';
export var COOKIE_PREFIX = '_up_web_role_';

/**
 * @description 将角色信息转化为字符串，然后进行字符串转换，以便存储在cookie中
 * @param gid {number} 游戏id
 * @param role {String | Object} 角色信息
 * @return roleString {String}
 */
export var encodeRole = function encodeRole(gid, role) {
  if (!gid || !role) return '';
  var roleText = JSON.stringify({
    gid: gid,
    role: role
  });
  return encodeURIComponent(roleText);
};

/**
 * @description 将转码后的角色信息字符串转化为Object
 * @param roleText {String}
 * @param roleKey {String} cookie中的key值
 * @return role {Object} 角色信息
 */
export var decodeRole = function decodeRole(roleText, roleKey) {
  var text = decodeURIComponent(roleText);
  try {
    var info = JSON.parse(text);
    return _objectSpread(_objectSpread({}, info), {}, {
      roleKey: roleKey
    });
  } catch (e) {
    console.warn("\u89D2\u8272\u4FE1\u606F\u89E3\u6790\u5931\u8D25\uFF0C \u539F\u59CB\u6570\u636E: ".concat(roleText), e);
    return null;
  }
};

/**
 * @description 生成随机cookie key
 */
export var createRandomCookieKey = function createRandomCookieKey() {
  return "".concat(COOKIE_PREFIX).concat(Math.random().toString(36).slice(-8));
};

/**
 * @description 从url中获取角色信息键值
 */
export var getCookieFromQuery = function getCookieFromQuery() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_COOKIE_KEY_OF_ROLE;
  return getParameterByName(key || DEFAULT_COOKIE_KEY_OF_ROLE) || '';
};

/**
 * @description 将cookie转化为结构体
 * @param str {String} cookie值
 * @returns {Object} cookie结构体
 */
function createCookiesMap(str) {
  var jar = {};
  var cookies = str ? str.split(/;\s?/) : [];
  cookies.forEach(function (parts) {
    var cookie = parts.split(/=/);
    // eslint-disable-next-line prefer-destructuring
    jar[cookie[0]] = cookie[1];
  });
  return jar;
}
/**
 * @description 将角色信息存储到cookie中
 * @param gid {number} 游戏id
 * @param role {Object | string} 角色信息
 * @param option {Object} 同步参数
 * @param option.domain {string} 目标域名
 * @param option.loginStatus {Function} milo syncToQQ函数句柄，默认获取window上的全局变量
 * @param option.key {string} 角色信息存储在cookie时的key值，默认会随机生成
 * @returns {Promise}
 */
export var saveRoleToCookie = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(gid, role) {
    var _window;
    var option,
      _option$domain,
      domain,
      loginStatus,
      key,
      roleText,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          option = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
          _option$domain = option.domain, domain = _option$domain === void 0 ? window.location.hostname : _option$domain;
          if (!(!gid || !role)) {
            _context.next = 5;
            break;
          }
          console.warn('gid/role 不能为空');
          return _context.abrupt("return", false);
        case 5:
          loginStatus = option.loginStatus || ((_window = window) === null || _window === void 0 || (_window = _window.milo) === null || _window === void 0 ? void 0 : _window.loginStatus);
          key = option.key || createRandomCookieKey();
          roleText = encodeRole(gid, role);
          return _context.abrupt("return", new Promise(function (resolve, _reject) {
            loginStatus.syncToQQ(domain, _defineProperty({}, key, roleText), function () {
              console.log('save Role success');
              resolve(key);
            });
          }));
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function saveRoleToCookie(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * @description 从cookie中获取角色信息
 * @param {string} param0.roleCookieKey 角色信息在cookie中的key值
 * @param {string} param0.queryCookieKey url中cookie key值
 * @returns
 */
export var getRoleFromCookie = function getRoleFromCookie() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref2$roleCookieKey = _ref2.roleCookieKey,
    roleCookieKey = _ref2$roleCookieKey === void 0 ? '' : _ref2$roleCookieKey,
    _ref2$queryCookieKey = _ref2.queryCookieKey,
    queryCookieKey = _ref2$queryCookieKey === void 0 ? '' : _ref2$queryCookieKey;
  var cookieMap = createCookiesMap(document.cookie);
  // 如果有指定的cookie key，则优先使用，如果没有，从url中获取对应的key
  var roleKey = roleCookieKey || getCookieFromQuery(queryCookieKey);
  var roleText = cookieMap[roleKey];
  if (!roleText) {
    console.warn("cookie\u4E2D\u627E\u4E0D\u5230\u5BF9\u5E94\u7684\u89D2\u8272\u4FE1\u606F\uFF0Ckey\u4E3A".concat(roleKey));
    return null;
  }
  return decodeRole(roleText, roleKey);
};